"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStorage = void 0;
var tslib_1 = require("tslib");
var TokenStorage_1 = require("./TokenStorage");
var GlobalStorage = /** @class */ (function (_super) {
    tslib_1.__extends(GlobalStorage, _super);
    function GlobalStorage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a global token storage instance for the given origin
     * A global token storage use a global variable to store the actual origin tokens
     * @param origin
     * @return
     */
    GlobalStorage.create = function (origin) {
        return Promise.resolve(new GlobalStorage(origin, GlobalStorage.tokens[origin]));
    };
    /**
     * @inheritDoc
     */
    GlobalStorage.prototype.saveToken = function (origin, token, temporary) {
        if (!temporary) {
            if (token) {
                GlobalStorage.tokens[origin] = token;
            }
            else {
                delete GlobalStorage.tokens[origin];
            }
        }
    };
    GlobalStorage.tokens = {};
    return GlobalStorage;
}(TokenStorage_1.TokenStorage));
exports.GlobalStorage = GlobalStorage;
TokenStorage_1.TokenStorage.GLOBAL = GlobalStorage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2xvYmFsU3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkdsb2JhbFN0b3JhZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLCtDQUE4QztBQUU5QztJQUFtQyx5Q0FBWTtJQUEvQzs7SUF5QkEsQ0FBQztJQXRCQzs7Ozs7T0FLRztJQUNJLG9CQUFNLEdBQWIsVUFBYyxNQUFjO1FBQzFCLE9BQU8sT0FBTyxDQUFDLE9BQU8sQ0FBQyxJQUFJLGFBQWEsQ0FBQyxNQUFNLEVBQUUsYUFBYSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDbEYsQ0FBQztJQUVEOztPQUVHO0lBQ0gsaUNBQVMsR0FBVCxVQUFVLE1BQWMsRUFBRSxLQUFhLEVBQUUsU0FBa0I7UUFDekQsSUFBSSxDQUFDLFNBQVMsRUFBRTtZQUNkLElBQUksS0FBSyxFQUFFO2dCQUNULGFBQWEsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLEdBQUcsS0FBSyxDQUFDO2FBQ3RDO2lCQUFNO2dCQUNMLE9BQU8sYUFBYSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQzthQUNyQztTQUNGO0lBQ0gsQ0FBQztJQXZCYyxvQkFBTSxHQUFpQyxFQUFFLENBQUM7SUF3QjNELG9CQUFDO0NBQUEsQUF6QkQsQ0FBbUMsMkJBQVksR0F5QjlDO0FBekJZLHNDQUFhO0FBMkIxQiwyQkFBWSxDQUFDLE1BQU0sR0FBRyxhQUFhLENBQUMifQ==